import _ from 'lodash';
import { AuthActionType } from "../../actions/auth/authAction";
import { v4 as uuidv4 } from 'uuid';
import {convertRoutes, extractKeys, filterRoutes} from "../../utils/globalFunction";
import adminRoutes from "../../adminRoutes";
import LocalStorage from "../../utils/LocalStorage";
import {LOCAL_STORAGE_ITEMS} from "../../constants";


const defaultState = {
  user: undefined,
  error: undefined,
  success: undefined,
  auth: [],
  role: undefined,
  authUser: undefined,
  verification:undefined,
  loading:false,
  userSetting: undefined,
  multiAddressList:[],
  multiAddressListTotal:0,
  menuList:[],
  currentRoutes:[...adminRoutes],
  userType:null
}

export const authReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case AuthActionType.Login:
      return {...state, success: true, error: undefined};
    case AuthActionType.Logout:
      return defaultState;
    case AuthActionType.AuthCheck:
      return {
        ...state, success: true,
        user: action.payload.user,
        auth: action.payload.auth,
        error: undefined
      }
    case AuthActionType.AuthError:
      return {...state, success: false, user: null, error: action.payload, responseAt: new Date()}
    case AuthActionType.FetchUserRole:
      return {...state, role: action.payload,loading: false}
    case AuthActionType.CHANGE_LOADING:
      return {...state, loading: action.payload}
    case AuthActionType.AuthUser:
      return {...state, authUser: action.payload}
    case AuthActionType.FetchVerification:
      return {...state, verification: action.payload}
    case AuthActionType.UserSetting:
      return {...state, userSetting: action.payload?.data?.userInfo}
    case AuthActionType.MultiAddressList:
      return {...state, multiAddressList: action.payload.rows?action.payload.rows.map((item, index) => {
          return { ...item, id: uuidv4() };}):[], multiAddressListTotal:action.payload.total}

    case AuthActionType.Set_Current_Routes:
      return {...state, currentRoutes: action.payload}

    case AuthActionType.User_Type:

      return {...state, userType: action.payload}
    case AuthActionType.Get_Routes:


      const keys = extractKeys(convertRoutes(action.payload))
      const filteredRoutes = filterRoutes([...adminRoutes], keys)
      LocalStorage.setItem('keys',JSON.stringify(keys))
      LocalStorage.setItem('menu',JSON.stringify(convertRoutes(action.payload)))

      return {...state, menuList: action.payload ,currentRoutes: filteredRoutes}


    default:
      return state;
  }

}
export default authReducer